module.exports = "/_next/static/images/d6ba22334d86fb4857a71195d1a9d7c7-roxinho-basicos-flutuantes-md@3x.png.webp";